import React, {useState, useEffect, useContext, useMemo, useCallback} from 'react';
import getConfig from 'next/config';

import RatingItem from '~/src/components/rating/item/RatingItem';
import Context from '~/src/components/context/Context';
import {SettingsContext} from '~/src/components/context/SettingsContext';

import {getQuestions, rateAsset, isRated} from '~/src/utilities/helpers/rating';
import {TypeContext} from '~/src/components/context/TypeContext';
import {ContentType} from '~/src/utilities/constants/types';
import {Hashes} from '~/src/utilities/constants/hash';
import {classNames} from '~/src/utilities/helpers/css';
import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './Rating.module.scss';
import i18nStrings from './Rating.i18n.json';

const {publicRuntimeConfig} = getConfig();
const getTranslation = initPolyglot(i18nStrings);

const Rating = ({metadataId, onRating}) => {
    useContext(Context);

    const {siteArea} = useContext(SettingsContext);
    const type = useContext(TypeContext);
    const [questions, setQuestions] = useState();

    const classes = classNames(css, 'rating', siteArea);

    const assetId = useMemo(() => `${publicRuntimeConfig.tenantId}/${metadataId}`, []);

    const onRatingAction = useCallback((question, rating) => {
        onRating(question, rating);
        rateAsset(question.questionId, assetId, rating);
    }, []);

    process.browser &&
        useEffect(() => {
            (async () => {
                setQuestions(await getQuestions(assetId, type === ContentType.LIFESTYLE ? ContentType.ARTICLE : type));
            })();
        }, []);

    return (
        <section className={classes} id={Hashes.RATING_SECTION} data-testid="Rating">
            <h4 className={css.title}>{getTranslation('title')}</h4>
            {questions && (
                <div className={css.content}>
                    {questions.map((question, index) => (
                        <RatingItem
                            key={`rating_item_${index}`}
                            question={question}
                            onRating={onRatingAction}
                            isUpRated={isRated(question.questionId, assetId, true)}
                            isDownRated={isRated(question.questionId, assetId, false)}
                        />
                    ))}
                </div>
            )}
        </section>
    );
};

export default Rating;
